import { useEffect, useState } from "react";
import Lenis from "lenis";
import api from "@/lib/api";
import { PasswordGate } from "@/components/PasswordGate";
import { Hero } from "@/components/Hero";
import { MarqueeRibbon } from "@/components/MarqueeRibbon";
import { PlanChapter } from "@/components/PlanChapter";
import { LocationChapter } from "@/components/LocationChapter";
import { StayChapter } from "@/components/StayChapter";
import { RsvpSection } from "@/components/RsvpSection";

export default function PartyPage() {
  const [auth, setAuth] = useState(null);

  useEffect(() => {
    api.get("/auth/site/me").then(() => setAuth(true)).catch(() => setAuth(false));
  }, []);

  useEffect(() => {
    if (!auth) return;
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, [auth]);

  if (auth === null) {
    return <div className="min-h-screen bg-[#050505]" data-testid="party-loading" />;
  }

  if (!auth) {
    return (
      <PasswordGate
        overline="Strictly confidential"
        title={<>You are <em className="text-gold">invited</em>.</>}
        subtitle="This celebration is a surprise. Enter the password from your invitation to reveal the plan — and not a word to Lindsay."
        testIdPrefix="site"
        onSubmit={async (password) => {
          await api.post("/auth/site", { password });
          setAuth(true);
        }}
      />
    );
  }

  return (
    <main data-testid="party-site">
      <Hero />
      <MarqueeRibbon />
      <PlanChapter />
      <LocationChapter />
      <StayChapter />
      <RsvpSection />
      <footer className="border-t border-white/10 px-6 py-12 md:px-16 lg:px-24" data-testid="site-footer">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <p className="font-display text-2xl font-light italic text-[#F5F5F0]">
            See you in the <span className="text-gold">dark</span>.
          </p>
          <div className="flex items-center gap-8">
            <p className="text-xs uppercase tracking-[0.25em] text-[#666666]">
              Saturday, 5 December 2026
            </p>
            <a
              href="/photos"
              data-testid="photos-link-footer"
              className="text-[10px] uppercase tracking-[0.25em] text-[#444444] transition-colors duration-300 hover:text-gold"
            >
              Share your photos
            </a>
            <a
              href="/admin"
              data-testid="admin-link-footer"
              className="text-[10px] uppercase tracking-[0.25em] text-[#444444] transition-colors duration-300 hover:text-gold"
            >
              Organiser access
            </a>
          </div>
        </div>
      </footer>
    </main>
  );
}
